import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe5d5c52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-comment" }
const _hoisted_2 = { class: "comment-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-title" }, "评论")
], -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "avatar-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" }, null, -1))
const _hoisted_7 = { class: "comment-list-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "全部评论", -1))

import { provide, toRef, useSlots } from 'vue'
import CommentBox from './comment-box.vue'
import CommentList from './comment-list.vue'
import {
  CommentApi,
  CommentSubmitParam,
  ConfigApi,
  ContentBoxParam,
  InjectionCommentFun,
  InjectionContentBox,
  InjectionReply,
  ReplyParam
} from './interface'
import { InjectionEmojiApi } from '../emoji/interface'

interface Props {
  config: ConfigApi
}


export default /*#__PURE__*/_defineComponent({
  __name: 'comment',
  props: {
    config: null
  },
  emits: ["submit", "like", "replyMore", "replyPage", "getUser", "report", "remove"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', content: string, parentId: number | null, finish: (comment: CommentApi) => void): void
  (e: 'like', id: number, finish: () => void): void
  (e: 'replyMore', parentId: number, closeLoad: any): void
  (e: 'replyPage', parentId: number, pageNum: number, pageSize: number): void
  (e: 'getUser', id: number, show: any): void
  (e: 'report', id: number, finish: () => void): void
  (e: 'remove', id: number, finish: () => void): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  config: ConfigApi
}


const slots = useSlots()
// 将这个属性转换为响应式数据。
const comments = toRef(props.config, 'comments')



const submit = (obj: CommentSubmitParam) => {
  emit('submit', obj.content, obj.parentId, (comment: CommentApi) => {
    // 添加内容回调处理,添加到评论列表
    obj.finish()
    if (obj.parentId) {
      let raw_comment = comments.value.find(v => v.id == obj.parentId)
      if (raw_comment) {
        let reply = raw_comment.reply
        if (reply) {
          reply.list.unshift(comment)
          reply.total++
        } else {
          raw_comment.reply = {
            total: 1,
            list: [comment]
          }
        }
      }
    } else {
      comments.value.unshift(comment)
    }
  })
}

const like = (id: number) => {
  // 点赞评论数组处理
  const editLike = (id: number, count: number) => {
    let tar = null
    comments.value.forEach(v => {
      if (v.id != id) {
        tar = v.reply?.list.find(v => v.id == id)
      } else {
        tar = v
      }
      if (tar) {
        tar.like += count
      }
    })
  }

  // 点赞事件处理
  let likes = props.config.user.likes
  emit('like', id, () => {
    if (likes.indexOf(id) == -1) {
      // 点赞
      likes.push(id)
      editLike(id, 1)
    } else {
      // 取消点赞
      let index = likes.findIndex(item => item == id)
      if (index != -1) likes.splice(index, 1)
      editLike(id, -1)
    }
  })
}

const reply: ReplyParam = {
  replyMore: (parentId, closeLoad) => emit('replyMore', parentId, closeLoad),
  replyPage: (parentId, pageNum, pageSize) => emit('replyPage', parentId, pageNum, pageSize)
}

const contentBox: ContentBoxParam = {
  user: props.config.user,
  like: like,
  isUserInfo: slots.userInfo != undefined,
  getUser: (uid, show) => emit('getUser', uid, show),
  report: (id, finish) => emit('report', id, finish),
  remove: (id, parentId, finish) =>
    emit('remove', id, () => {
      // 删除操作回调处理
      finish()
      if (parentId) {
        let comment = comments.value.find(item => item.id == parentId)
        let reply = comment?.reply
        if (reply) {
          let index = reply.list.findIndex(item => item.id == id)
          if (index != -1) {
            reply.list.splice(index, 1)
            reply.total--
          }
        }
      } else {
        let index = comments.value.findIndex(item => item.id == id)
        if (index != -1) {
          comments.value.splice(index, 1)
        }
      }
    })
}

provide(InjectionCommentFun, submit)
provide(InjectionEmojiApi, props.config.emoji)
provide(InjectionReply, reply)
provide(InjectionContentBox, contentBox)

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_avatar, {
            size: 40,
            src: __props.config.user.avatar
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["src"])
        ]),
        _createVNode(CommentBox, {
          placeholder: "输入评论（Enter换行，Ctrl + Enter发送）",
          "content-btn": "发表评论"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "list-title", {}, () => [
        _hoisted_8
      ]),
      _createVNode(CommentList, { data: _unref(comments) }, {
        userInfo: _withCtx(() => [
          _renderSlot(_ctx.$slots, "userInfo")
        ]),
        _: 3
      }, 8, ["data"])
    ])
  ]))
}
}

})